import { GatewayTicketModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tickets/models/outputs/gateway-ticket.model';
import { TicketRelatedResourceType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/support-service-lib/src/wrapper/enums/ticket-related-resource-type.enum';

import { useCpmsBoGetChargePointQuery } from '@service/cpms-bo-charge-point.service';
import { useCpmsBoGetLocationQuery } from '@service/cpms-bo-location.service';

export interface TicketScope {
  customerId?: string;
  networkId?: string;
  isLoading: boolean;
}

// The ticket API does not return its customer/network: derive them from the
// location or charge point it is related to.
export const useTicketScope = ({
  relatedResources,
}: Pick<GatewayTicketModel, 'relatedResources'>): TicketScope => {
  const chargePointId = relatedResources.find(
    ({ type }) => type === TicketRelatedResourceType.ChargePoint,
  )?.id;
  const locationId = relatedResources.find(
    ({ type }) => type === TicketRelatedResourceType.Location,
  )?.id;

  const { data: chargePoint, isLoading: isChargePointLoading } =
    useCpmsBoGetChargePointQuery(chargePointId ?? '', {
      skip: !chargePointId,
    });
  const { data: location, isLoading: isLocationLoading } =
    useCpmsBoGetLocationQuery(locationId ?? '', {
      skip: !locationId || !!chargePointId,
    });

  const resource = chargePoint ?? location;

  return {
    customerId: resource?.customer.id,
    networkId: resource?.network.id,
    isLoading: isChargePointLoading || isLocationLoading,
  };
};
